export default {
  organizationTypes: [],
};



// WEBPACK FOOTER //
// ./src/app/store/modules/organizationType/state.js